import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const CenteredTable = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`;
